const release = "sportident-tibi-2024.r339-heads-master-0-g5127de2"

const originURL = "https://www.sportident.com"
const apiClientBaseURL = "/tibiapi/"

const cryptchaSiteId = "6628f06a0938460001505119"

// @ts-ignore
if (release && typeof context !== "undefined") {
    context.response.header("X-Release", release)
}

const isMaster = release.includes("master")

module.exports = {
    release,
    apiClientBaseURL,
    originURL,
    cryptchaSiteId,
    sportidentApiBase: isMaster
        ? "https://neptune-net.production.mar.sportident.com/api/grpc-json/v1/"
        : "https://neptune-net.staging.mar.sportident.com/api/grpc-json/v1/",
    sportidentApiClientId: "www.sportident.com-a0e5dd01-6954-4479-a0fd-58575371e048",
}
